<template>
  <v-bottom-navigation v-if="isAdmin && isMobile" bg-color="primary"> <!-- Visão do Admin -->
    <v-btn @click="$router.push('/')">
      <span>Início</span>
      <v-icon>mdi-home</v-icon>
    </v-btn>

    <v-btn @click="$router.push('/dashboard')">
      <span>Dashboard</span>
      <v-icon>mdi-monitor-dashboard</v-icon>
    </v-btn>

    <v-btn @click="logout">
      <span>Sair</span>
      <v-icon>mdi-logout</v-icon>
    </v-btn>
  </v-bottom-navigation>

  <v-bottom-navigation v-if="!isAdmin && isMobile" bg-color="primary"> <!-- Visão do Usuário -->
    <v-btn @click="$router.push('/')">
      <span>Início</span>
      <v-icon>mdi-home</v-icon>
    </v-btn>

    <v-btn @click="$router.push('/validar-senha')">
      <span>Minha Senha</span>
      <v-icon>mdi-check-decagram</v-icon>
    </v-btn>

    <v-btn @click="$router.push('/login')">
      <span>Login</span>
      <v-icon>mdi-account-key</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
  import { useAppStore } from '@/stores/app'

  export default {
    name: 'MenuBottom',
    computed: {
      isAdmin() {
        const store = useAppStore();
        return store.getIsLoggedIn;
      },
      isMobile() {
        return this.$vuetify.display.mobile;
      }
    },
    methods: {
      logout() {
        localStorage.removeItem('token');
        this.$router.push('/login');
        this.axios.defaults.headers.common.Authorization = '';
      }
    }
  }
</script>

<style scoped>

</style>
